import React from 'react';
import {
  Box,
  Button,
  Grid,
  Slide,
  Typography
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  GetAppOutlined
} from '@mui/icons-material';

import styles from '../../style';
import {
  SystemDefined,
  UserDefined
} from './components';

const CPT = () => {
  return (
    <Slide
      direction="left"
      in
      mountOnEnter
      timeout={200}
      unmountOnExit
    >
      <Grid
        container
        spacing={3}
        sx={styles.icdWrap}
      >
        <Grid size={{ xs: 12 }}>
          <Typography
            component="p"
            sx={styles.tabLabel}
          >
            CPT Database
          </Typography>
        </Grid>

        <Grid
          size={{ md: 5, xs: 12 }}
          sx={styles.icdLeft}
        >
          <UserDefined />
        </Grid>

        <Grid
          size={{ md: 2, xs: 12 }}
          sx={styles.icdCenter}
        >
          <Box sx={styles.icdCtrls}>
            <Button
              aria-label="Move selected CPT item left"
              sx={styles.icdCtrlBtn1}
              variant="contained"
            >
              <ChevronLeft />
            </Button>

            <Button
              aria-label="Move selected CPT item right"
              sx={styles.icdCtrlBtn2}
              variant="contained"
            >
              <ChevronRight />
            </Button>

            <Button
              aria-label="Import CPT database"
              color="primary"
              sx={styles.icdCtrlBtn3}
              variant="contained"
            >
              <GetAppOutlined />
            </Button>
          </Box>
        </Grid>

        <Grid
          size={{ md: 5, xs: 12 }}
          sx={styles.icdRight}
        >
          <SystemDefined />
        </Grid>
      </Grid>
    </Slide>
  );
};

export default CPT;